module.exports = __webpack_public_path__ + "static/media/logoWhite.22046256.svg";